import { render, staticRenderFns } from "./AffiliateStaff.vue?vue&type=template&id=250230cf&scoped=true&"
import script from "./AffiliateStaff.vue?vue&type=script&lang=js&"
export * from "./AffiliateStaff.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateStaff.vue?vue&type=style&index=0&id=250230cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250230cf",
  null
  
)

export default component.exports